export function getSalutationIntro(salutaion) {
  return salutaion && salutaion.startsWith('Frau')
    ? 'salutation-intro-female'
    : 'salutation-intro-male';
}
